import { PREVIEW_GEOMETRY_SCALE } from '../../../constants/size';
import { GLTFLoadPromise } from '../../../../vendors/ngab/threejs/load/GLTFLoadPromise';

const THREE = require('three');

//
// Prepared geometries storage:
// (e.g. preloaded)

// const geometriesMap = new Map();

const fixUV = (geom, w, h, xs, ys) => {
    const { array } = geom.attributes.uv;
    const newArray = new Float32Array(array.length);

    const n = 2;
    let i;

    for (i = 0; i < array.length; i += n) {
        newArray[i] = (array[i] - xs) / w;
        newArray[i + 1] = (array[i + 1] - ys) / h;
    }

    geom.setAttribute('uv', new THREE.BufferAttribute(newArray, n));
};

export const GeometriesFactory = {
    async create(type, data) {
        // Default type is 'rect'
        // Add switch instructions to add options

        const KAPPA = 0.5522848;
        let geom = null;
        let shape = null;
        let loaded;
        let error;
        let w;
        let h;
        let xs;
        let ys;
        let ox;
        let oy;
        let xe;
        let ye;
        let xm;
        let ym;
        const {
            width, height, anchor, src
        } = data;
        let { scale, wSegments, hSegments } = data;

        scale = scale ?? 1;
        wSegments = wSegments ?? 1;
        hSegments = hSegments ?? 1;

        switch (type) {
            case 'rect':
                geom = new THREE.PlaneBufferGeometry(
                    width * PREVIEW_GEOMETRY_SCALE * scale,
                    height * PREVIEW_GEOMETRY_SCALE * scale,
                    wSegments,
                    hSegments
                );

                break;

            case 'frame':
                shape = new THREE.Shape();

                w = width * PREVIEW_GEOMETRY_SCALE * scale;
                h = height * PREVIEW_GEOMETRY_SCALE * scale;

                // start
                xs = -w / 2;
                ys = -h / 2;
                // offset
                ox = (w / 2) * KAPPA;
                oy = (h / 2) * KAPPA;
                // end
                xe = xs + w;
                ye = ys + h;
                // middle
                xm = xs + w / 2;
                ym = ys + h / 2;

                shape.moveTo(xs, ym);
                shape.bezierCurveTo(xs, ym - oy, xm - ox, ys, xm, ys);
                shape.bezierCurveTo(xm + ox, ys, xe, ym - oy, xe, ym);
                shape.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
                shape.bezierCurveTo(xm - ox, ye, xs, ym + oy, xs, ym);

                geom = new THREE.ShapeBufferGeometry(shape);

                fixUV(geom, w, h, xs, ys);

                break;

            case 'gltf':
                loaded = await GLTFLoadPromise(src);

                if (loaded.scene) {
                    geom = loaded.scene;

                    if (geom.children.length === 1) [geom] = geom.children;
                } else {
                    error = loaded;
                }

                break;

            default:
                geom = null;

                break;
        }

        if (geom instanceof THREE.Mesh) {
            geom = geom.geometry;
        }
        if (geom instanceof THREE.BufferGeometry) {
            if (anchor) {
                let { x, y, z } = anchor;

                x = x ?? 0;
                y = y ?? 0;
                z = z ?? 0;

                geom.translate(x, y, z);
            }
        }

        if (error instanceof Error) {
            console.warn(`Failed to get the geometry ${data}: ${geom}`);
        }

        return geom;
    }
};
